import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Form, TextArea, Button, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {getDetailAmount} from './utils';

const aerialTransportation = 'A';

class Generator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isOpen': false,
      'description': '',
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleGenerateClick = this.handleGenerateClick.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false, 'description': ''});
  }

  handleDescriptionChange(event, data) {
    this.setState({'description': data.value});
  }

  checkInvalidValues(orderDetail) {
    return orderDetail.some((element) =>
      !element.partCode || !element.partQuantity || !element.name);
  }
  
  handleGenerateClick() {
    const {detail, transport, provider} = this.props;

    if (!detail.length) {
      this.props.addMessageBoxError('Por favor verifique que exista al menos un repuesto para el pedido');
      return;
    }

    if (this.checkInvalidValues(detail)) {
      this.props.addMessageBoxError('Por favor verifique que todos los elementos posean información válida');
      return;
    }

    const submitFunction = this.getAuthorizationStatus() ?
      this.props.askForProviderManualOrderAuthorization : this.props.processProviderManualOrder;

    submitFunction({
      'shipmentOrder': transport,
      'provider': provider,
      'orders': detail,
      'authorizationDescription': this.state.description,
    });
    this.handleClose();
  }

  getAuthorizationStatus() {
    const {detail, transport, totalLimit, totalValue} = this.props;
    return transport === aerialTransportation && ((totalValue + getDetailAmount(detail)) > totalLimit);
  }

  getButtonDisableStatus() {
    const {detail, loading, provider, transport, orderType} = this.props;
    return loading || !detail.length || !provider || !transport || !orderType;
  }

  disableAuthorization() {
    const {description} = this.state;
    return !description || description.length < 5;
  }

  render() {
    const {loading} = this.props;
  
    if (this.getAuthorizationStatus()) {
      return (
        <Popup wide
          on='click'
          position='left center'
          open={this.state.isOpen}
          onOpen={this.handleOpen}
          onClose={this.handleClose}
          trigger={
            <Button primary
              disabled={this.getButtonDisableStatus()}
              onClick={this.handleOpen}
              content='SOLICITAR AUTORIZACION'
            />
          }
        >
          <Grid className='manual-order-authorization'>
            <Grid.Row>
              <Grid.Column textAlign='center'>
                <div>Ingrese el motivo para solicitar la autorización.</div>
                <Form>
                  <TextArea
                    rows={2}
                    value={this.state.description}
                    onChange={this.handleDescriptionChange}
                  />
                </Form>
                <br />
                <Button secondary
                  size='mini'
                  content='CANCELAR'
                  onClick={this.handleClose}
                />
                <Button primary
                  size='mini'
                  content='ACEPTAR'
                  disabled={this.disableAuthorization()}
                  onClick={this.handleGenerateClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Popup>
      );
    }

    return (
      <Button primary
        disabled={this.getButtonDisableStatus()}
        loading={loading}
        onClick={this.handleGenerateClick}
        content='GENERAR'
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerManualOrder.loading,
    'detail': state.providerManualOrder.detail,
    'provider': state.providerManualOrder.provider,
    'transport': state.providerManualOrder.transport,
    'orderType': state.providerManualOrder.orderType,
    'totalLimit': state.providerOrdersControl.totalLimit,
    'totalValue': state.providerOrdersControl.totalValue,
  };
};

const {
  addMessageBoxError,
  processProviderManualOrder,
  askForProviderManualOrderAuthorization,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  processProviderManualOrder,
  askForProviderManualOrderAuthorization,
})(Generator);
